import { t } from 'i18next';

export enum HandshakeStatus {
  INCOMPLETE = 'INCOMPLETE',
  SUCCESS = 'SUCCESS',
}

export const getHandshakeStatusLabel = (status: HandshakeStatus): string => {
  return t(`handshakes.properties.status.${status}`);
};
